import { Platform} from 'react-native';

export const configureFonts = (config) => Platform.select(config);


